import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#searchBtn'
const _hoisted_2 = { class: "catalog-menu" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "catalog-menu__container" }
const _hoisted_5 = { class: "catalog-menu__header" }
const _hoisted_6 = { class: "catalog-menu__list" }
const _hoisted_7 = {
  key: 0,
  class: "loader"
}

import CartModal from "@/components/CartModal.vue";
  import CatalogMenuItem from "@/components/CatalogMenuItem.vue";
  import { ISectionsItem } from "@/models/models";
  import { ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogMenu',
  setup(__props) {

  const sections = ref<Array<ISectionsItem>>([] as Array<ISectionsItem>);

  const isLoading = ref<boolean>(true as boolean);

  fetch("https://akshop.a-dev.xyz/api/v1/sections")
    .then((response) => response.json())
    .then((data) => {
      sections.value = data.sections;
      isLoading.value = false;
    });

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Каталог", -1)),
            _createVNode(_component_RouterLink, { to: "/search" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  width: "36",
                  height: "36"
                }, [
                  _createElementVNode("use", { "xlink:href": _hoisted_1 })
                ], -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "loader-spinner" }, null, -1)
                ])))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(sections.value, (item) => {
                  return (_openBlock(), _createBlock(CatalogMenuItem, { data: item }, null, 8, ["data"]))
                }), 256))
          ])
        ])
      ])
    ]),
    _createVNode(CartModal)
  ], 64))
}
}

})